import React from 'react';
import { NavLink } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';

import { ArrowRightIcon } from '../../img/icons';
import SpinLoader from '../SpinLoader';

import messages from './messages';

import line7Img from '../../img/courseAccessButton/line-7.svg';

interface CourseAccessButtonProps {
  duration: string;
  eligibleToEnroll: boolean;
  Loaded: boolean;
  isLoading: boolean;
  courseCompleted?: boolean;
  isGuest?: boolean;
  handleEnrollUser: (e: React.MouseEvent) => void;
}

const CourseAccessButton: React.FC<CourseAccessButtonProps> = ({
  duration, eligibleToEnroll, Loaded, courseCompleted, handleEnrollUser, isLoading, isGuest,
}) => {
  const intl = useIntl();

  const getAccessStatusText = () => {
    if (isGuest) {
      return intl.formatMessage(messages.signInToEnroll);
    }
    if (Loaded && eligibleToEnroll) {
      return intl.formatMessage(courseCompleted ? messages.complete : messages.availableNow);
    }
    return intl.formatMessage(messages.completePreviousModule);
  };

  return (
    <div className="course-info-panel">
      <div className="time-1-2-hours">
        <span className="instrumentserif-normal-congress-blue-22-8px">
          {intl.formatMessage(messages.timeLabel)}:
        </span>
        {' '}
        <span className="span1 course-time">
          {duration}
        </span>
      </div>
      <div className="frame-21">
        <img className="line-8" src={line7Img} alt="" />
        <div className="access-open">
          <span className="instrumentserif-normal-congress-blue-22-8px">
            {intl.formatMessage(messages.accessLabel)}:
          </span>
          {' '}
          <span className="span1 access-status">
            {getAccessStatusText()}
          </span>
        </div>
      </div>
      <div className="course-cta">
        <div>
          {(isGuest || (Loaded && eligibleToEnroll)) && (
            isLoading ? (
              <SpinLoader size={40} containerHeight="150px" />
            ) : (
              <NavLink
                to="#"
                onClick={handleEnrollUser}
                className="align-self-flex-start"
              >
                <div className="button">
                  <div className="text-2 instrumentsans-normal-white-26px">
                    <ArrowRightIcon />
                  </div>
                </div>
              </NavLink>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseAccessButton;
